export default __webpack_public_path__ + "static/media/watch.5cdaa594.png";